import React from "react"
import { LandingBanner } from "./LandingBanner"
import { FilterFetch } from "./FilterFetch"
import { ArticleList } from "./ArticleList"
import { BottomCategoriesFetch } from "./BottomCategoriesFetch"
import { SEOHome } from "../../../utils/SEOHome"

export const HomeBody = ({ data }) => {
	return (
		<>
			<SEOHome data={data} />
			{/* <LandingBanner data={data} /> */}
			<FilterFetch data={data} />
			<ArticleList data={data} />
			<BottomCategoriesFetch data={data} />
		</>
	)
}

// need to take in
